import { render, staticRenderFns } from "./AdsBuy.vue?vue&type=template&id=9180ad68"
import script from "./AdsBuy.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdsBuy.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports